var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-pagination',{attrs:{"align":"center","size":"md","total-rows":_vm.count,"value":_vm.pageNumber,"per-page":_vm.size},on:{"change":_vm.userChangedPage}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }